import { Component, OnInit } from '@angular/core';
import { ContentfulService } from '../contentful.service';
import { Observable } from 'rxjs/Observable';
import { Entry } from 'contentful';

@Component({
  selector: 'app-productlist',
  templateUrl: './productlist.component.html',
  styleUrls: ['./productlist.component.scss']
})
export class ProductlistComponent implements OnInit {

  categories: Entry<any>[];


  constructor(private contentful: ContentfulService) { }

  ngOnInit() {
    this.contentful.getCategories()
      .then(categories => {
        this.categories = categories;
        console.log(this.categories);
      });


  }




}



// WEBPACK FOOTER //
// /Users/akirchhoff/Documents/Development/routerProducts/src/app/productlist/productlist.component.ts